import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {BannerListWrapper} from './banner-list/RoleList'
import { useNavigate } from 'react-router-dom'; 
import { AlertContext } from '../../../../../_metronic/layout/components/alert-context';
import { useContext, useEffect } from 'react';
import AddBanner from './banner-form/AddBanner';
import { EditBannerWrapper } from './banner-form/EditBannerWrapper';
 

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Mobile Settings list',
    path: '/mobile-settings',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const BannerPage = () => {
  const navigate = useNavigate();
  function goBack() {
     
    navigate(-1);
  }
  const { hideAlert } = useContext(AlertContext);
  useEffect(() => {
    hideAlert(false);
  }, []);
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Mobile Settings list</PageTitle>
              <button onClick={goBack} style={{marginBottom:"15px"}}  className='btn btn-sm btn-info px-6 align-self-center text-nowrap'> 
           <i className="bi bi-reply fs-4 me-2"></i> Go Back </button> 
              <BannerListWrapper />
            </>
          }
        />
        <Route
          path='/banner/add'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Mobile Settings list</PageTitle>
              <button onClick={goBack} style={{marginBottom:"15px"}}  className='btn btn-sm btn-info px-6 align-self-center text-nowrap'> 
           <i className="bi bi-reply fs-4 me-2"></i> Go Back </button> 
              <AddBanner />
            </>
          }
        />
        <Route
          path='/banner/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Mobile Settings list</PageTitle>
              <button onClick={goBack} style={{marginBottom:"15px"}}  className='btn btn-sm btn-info px-6 align-self-center text-nowrap'> 
           <i className="bi bi-reply fs-4 me-2"></i> Go Back </button> 
              <EditBannerWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
    </Routes>
  )
}

export default BannerPage
